import React from 'react';

import { TextButton } from '@notino/react-styleguide-v20';

import { ETextDecoration } from '@sharedComponents/Buttons';
import { CartPrice } from '@sharedComponents/Prices';
import { getNumberInNegative } from '@utils/math';

export const PriceColumn = (value: number | undefined, isDualPriceLayout: boolean, isVoucher: boolean) =>
  value
    ? () => (
        <CartPrice
          isDualPriceLayout={isDualPriceLayout}
          price={getNumberInNegative(value)}
          isColumnLayout={true}
          isHighLighted={isVoucher}
        />
      )
    : null;

type ButtonContent = string | JSX.Element | undefined;
export const ButtonColumn = (
  buttonContent: ButtonContent,
  buttonContextHelp: string | undefined,
  onClick: (() => void) | undefined,
) =>
  buttonContent
    ? () => (
        <TextButton
          contextHelpText={buttonContextHelp}
          onClickAction={onClick}
          textDecoration={ETextDecoration.UNDERLINE}
          hasHover={true}
          disabled={false}>
          {buttonContent}
        </TextButton>
      )
    : null;
